import React, { useState, useEffect } from 'react';

import { voiceItemFinalizarAtendimentoSettings } from '../../../../util/getVoiceItemSettings';

import ButtonTestTts from './ButtonTestTts';
import SelectStatus from './SelectStatus';

export default ({ doUpdateItem, item }) => {
  const [itemSettings, setItemSettings] = useState(
    voiceItemFinalizarAtendimentoSettings
  );

  useEffect(() => {
    if (item && item.voiceSettings) {
      setItemSettings(item.voiceSettings);
    }
  }, [item]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const newValue = type === 'checkbox' ? checked : value;
    const updatedSettings = { ...itemSettings, [name]: newValue };

    setItemSettings(updatedSettings);
    doUpdateItem({ voiceSettings: updatedSettings });
  };

  return (
    <>
      <p className="handler-title">Finalizar Atendimento</p>

      <SelectStatus
        label="Status para ligação"
        value={itemSettings.idIvrStatus}
        onChange={handleInputChange}
      />

      <div className="common-form-group">
        <label>Código externo do Step (opcional)</label>
        <input
          className="form-control mt-1"
          value={itemSettings.codeIvrStepExternal}
          name="codeIvrStepExternal"
          onChange={handleInputChange}
        />
      </div>

      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            name="isCpc"
            id="isCpc"
            checked={itemSettings.isCpc}
            onChange={handleInputChange}
          />
          <label className="custom-control-label" htmlFor="isCpc">
            É CPC
          </label>
        </div>
      </div>

      <ButtonTestTts text={itemSettings.deScriptTts} />
    </>
  );
};
